// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-75a21fc1]:export{primary:#30556b;secondary:#818184;secondaryBright:#e3e3e3;accent:#30556b;textColor:#333;black:#000;neutralLight:#f4f4f4;neutralBright:#fbfbfb;textLinks:#fff;brandGrey:#50504f;success:#009245;siteBlue:#140fa5;siteGreen:#0a8735;liteGreen:#00be41;siteLiteBlue:#0078cd;sitePurple:#8c199b}.second-section[data-v-75a21fc1]{margin-right:14px;max-width:66%}.img-styling[data-v-75a21fc1]{margin-left:2%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
